import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
function Button({ children, isSpinnerVisible, className, variant, ...rest }) {  
    return (<button className={`${variant} ${className}`} {...rest}>
                {children}
                {isSpinnerVisible && <div className="spinner"></div>}
            </button>)
}
Button.propTypes={
    children:PropTypes.node.isRequired,
    isSpinnerVisible:PropTypes.bool,
    variant:PropTypes.string,
    className:PropTypes.string,
}
Button.defaultProps={
    isSpinnerVisible:false,
    className:"",
    variant:"primary-btn"
}
export default Button;